import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit 
{

  constructor(
    public translateService: TranslateService
  ) 
  { 
  }

  ngOnInit() 
  {
  }

}
